import {styled} from '@material-ui/core';
import Box from '@material-ui/core/Box';

export const Spacer = styled(Box)(() => ({
    flex: 1,
}));
